import { render } from "./manage-worktasks.vue?vue&type=template&id=096d5d7d"
import script from "./manage-worktasks.vue?vue&type=script&lang=js"
export * from "./manage-worktasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/workorganisation/manage-worktasks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "096d5d7d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('096d5d7d', __exports__)) {
    api.reload('096d5d7d', __exports__)
  }
  
  module.hot.accept("./manage-worktasks.vue?vue&type=template&id=096d5d7d", () => {
    api.rerender('096d5d7d', render)
  })

}


export default __exports__